module.exports = __webpack_public_path__ + "static/media/Grupo 1035@2x.6cf3eb3f.png";